import { appLocalStorage } from '@/app/shared/commonURLs'; 

//let LabRadUrl = appLocalStorage.LabRadUrl;
//let LabAnalyzerODataUrl = appLocalStorage.LabAnalyzerOData;
let LabRadServiceURL = appLocalStorage.LabRadServiceUrl;
let LabRadODataServiceURL = appLocalStorage.LabRadODataServiceUrl;
let HRODataServiceURL = appLocalStorage.HrOdataServiceUrl;
let pmgODataUrl = appLocalStorage.ProductManagementODataUrl;
let pmgUrl = appLocalStorage.ProductManagementUrl;

export class uRls {
    constructor() {
        this.LabRadServiceList = LabRadURLs();
        //this.PmgtServicesList = pmgtURLS();
    }
}

const LabRadURL = new uRls();
export { LabRadURL };


function LabRadURLs() {

    var services = {};
    //================ LabRad Setup  ======================
    // services["GetLabRadStaticData"] = {
    //     Method: 'Get',
    //     URL: LabRadUrl + 'LabRad/GetLabRadStaticData',
    // }
    services["GetTradeNameDetails"] = {
        Method: 'GET',
        URL: pmgUrl + 'Drug/GetTradeNameDetails'
    }
    services["GetTradeNamesOdata"] = {
        Method: 'Get',
        URL: pmgODataUrl + 'MedicationOData',
    },
    services["ProductRetrievalByClassification"] = {
        Method: 'Get',
        URL: pmgODataUrl + 'ProductByClassificationOData',
    },
    services["GetAllAnalyzerList"] = {
        Method: 'Get',
        URL: LabRadODataServiceURL + 'LabAnalyzerOData?'
    }
    services["GetOrganismOData"] = {
        Method: 'Get',
        URL: LabRadODataServiceURL + 'OrganismOData?'
    }
    services["GetAntiBioticService"] = {
        Method: 'Get',
        URL: LabRadODataServiceURL + 'AntibioticSensistivityOData?'
    }
    
    services["GetAllAnalyzerProducts"] = {
        Method: 'Get',
        URL: LabRadODataServiceURL + 'AnalyzerProductsOData?'
    }    
    services["SaveLabAnalyzer"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'LabAnalyzer/SaveLabAnalyzer'
    };  
    services["SaveOrganism"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'Organism/SaveOrganism'
    }; 
    services["DeletAntibiotic"] = {
        Method: 'DELETE',
        URL: LabRadServiceURL + 'AntibioticSensistivity/Delete'
    };
    services["SaveAntibiotic"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'AntibioticSensistivity/Save'
    };
    services["GetAntibioticGroup"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'AntibioticSensistivity/GetAntibioticGroup'
    };
    services["GetAntibioticClass"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'AntibioticSensistivity/GetAntibioticClass'
    };
    services["GenericRetrieval"] = {
        Method: 'GET',
        URL: pmgUrl + 'Generic/GenericRetrieval'
    };
    services["SaveAnalyzerProduct"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'LabAnalyzer/SaveAnalyzerProduct'
    };  
    services["EditAnalyzerProducts"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'LabAnalyzer/EditAnalyzerProducts'
    }; 
    
    services["IsInvestigationAssignedAsDefaultBefore"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'LabAnalyzer/IsInvestigationAssignedAsDefaultBefore'
    }; 
    services["EditLabAnalyzer"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'LabAnalyzer/EditLabAnalyzer'
    };
    services["EditOrganism"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'Organism/EditOrganism'
    };
    services["EditAntiBiotic"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'AntibioticSensistivity/Edit'
    };
    services["DeleteLabAnalyzer"] = {
        Method: 'DELETE',
        URL: LabRadServiceURL + 'LabAnalyzer/DeleteLabAnalyzer'
    };
    services["DeleteOrganism"] = {
        Method: 'DELETE',
        URL: LabRadServiceURL + 'Organism/DeleteOrganism'
    };
    services["DeleteAnalyzerProducts"] = {
        Method: 'DELETE',
        URL: LabRadServiceURL + 'LabAnalyzer/DeleteAnalyzerProducts'
    };
    
    services["GetAnalyzerStatus"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'LabAnalyzer/GetAnalyzerStatus'
    };
    services["GetTranfareTypes"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'LabAnalyzer/GetTranfareTypes'
    };
    
    services["InitCollectReCollectSpecimen"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'DonationInvestigation/InitCollectReCollectSpecimen'
    };

    services["GetLabRadEmployeesOData"] = {
        Method: 'Get',
        URL: HRODataServiceURL + 'EmployeesOdata'
    };

    services["SaveInvestigationSpecimenCollection"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'DonationInvestigation/SaveInvestigationSpecimenCollection'
    };

    services["GetDonationInvestigationOData"] = {
        Method: 'GET',
        URL: LabRadODataServiceURL + 'DonationInvestigationOData'
    };
    
    services["DonationInvestigationAfterOData"] = {
        Method: 'GET',
        URL: LabRadODataServiceURL + 'DonationInvestigationAfterOData'
    };

    services["GetDonationsInvestigationsCounts"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'DonationInvestigation/GetDonationsInvestigationsCounts'
    };

    services["GetDonationsInvestigationsFilterConf"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'SLKP_Configuration/GetDonationsInvestigationsFilterConf'
    };

    services["GetUndoAndRejectionReasons"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'DonationInvestigation/GetUndoAndRejectionReasons'
    };

    services["PerformDonationInvestigations"] = {
        Method: 'Put',
        URL: LabRadServiceURL + 'ServiceTransactionInstance/PerformDonationInvestigations'
    };

    services["CancelPerformDonationInvestigation"] = {
        Method: 'Put',
        URL: LabRadServiceURL + 'ServiceTransactionInstance/CancelPerformDonationInvestigation'
    };


    services["UndoInvestigationSpecimenCollect"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'DonationInvestigation/UndoInvestigationSpecimenCollect'
    };


    services["GetResultStatusConfigurationByStatusID"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationResult/GetResultStatusConfigurationByStatusID'
    };

    services["GetComponentsReferenceRanges"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationResult/GetComponentsReferenceRanges'
    };

    services["SaveDonationInvestigationResult"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'DonationInvestigation/SaveDonationInvestigationResult'
    };

    services["FinalizeDonationInvestigationResult"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'DonationInvestigation/FinalizeDonationInvestigationResult'
    };

    services["AddBulkPrintingLogForDonationInvestigation"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'InvestigationResult/AddBulkPrintingLogForDonationInvestigation'
    };


    services["GetCurrentUserName"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationResult/GetCurrentUserName'
    };

    services["GetShowLabEditResultReasonsConfig"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'SLKP_Configuration/GetShowLabEditResultReasonsConfig'
    };

    services["GetInvestigationResultByID"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationResult/GetInvestigationResultByID'
    };

    services["GetEditResultReasons"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationResult/GetEditResultReasons'
    };

    services["GetDonationInvestigationResult"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationResult/GetDonationInvestigationResult'
    };

    services["UpdateDonationInvestigationTechnicianNotes"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'InvestigationResult/UpdateDonationInvestigationTechnicianNotes'
    };

    services["GetDonationInvestigationHistory"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationHistory/GetDonationInvestigationHistory'
    };
    
    services["GetDonationCollectionDetails"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationHistory/GetDonationCollectionDetails'
    };
    
    services["SaveDonationCollectionPrinting"] = {
        Method: 'POST',
        URL: LabRadServiceURL + 'CollectionPrinting/SaveDonationCollectionPrinting'
    };

    services["GetInvestigationOrganisms"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationResult/GetInvestigationOrganisms'
    };

    services["GetAntibioticSensistivities"] = {
        Method: 'GET',
        URL: LabRadServiceURL + 'InvestigationResult/GetAntibioticSensistivities'
    };



    return services;
}
